import { createSelector } from "reselect"

import selectAllOfflineActivities from '../selectAllOfflineActivities'

export default createSelector(
    selectAllOfflineActivities,
    (activities) => {
        if (activities.length > 0) return activities[0].dateCreated
    }
)